import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ROUTES } from './routesConfig';
import { useAuthentication } from '../../hooks/useAuthentication';
import { EInvoicingPortal } from '../../pages/EInvoicingPortal';
import { PERMISSIONS } from '../../helpers/auth';

const AppRoutes = ({ baseRoute, TAX_COUNTRY }) => {
  const [routes, setRoutes] = useState([]);
  const [isInitialized, setIsInitialized] = useState(false);

  const { roles, hasRole } = useAuthentication();
  const renderRoutes = (appRoutes) => {
    return appRoutes.map((options, index) => {
      const { path, element, nestedRoutes } = options ?? {};
      return element ? (
        <Route key={path} path={path} element={element}>
          {nestedRoutes && nestedRoutes.length > 0
            ? renderRoutes(nestedRoutes)
            : null}
        </Route>
      ) : (
        <Route key={path} path={path}>
          {nestedRoutes && nestedRoutes.length > 0
            ? renderRoutes(nestedRoutes)
            : null}
        </Route>
      );
    });
  };

  useEffect(() => {
    const routeConfig = {
      showSolutionRegistration: hasRole(PERMISSIONS.VIEW_DEVICE),
      showDashboard: hasRole(PERMISSIONS.VIEW_DASHSBOARD),
      showTaxReturn: hasRole(PERMISSIONS.VIEW_INVOICE_STATEMENT),
      showInvoiceView: hasRole(PERMISSIONS.VIEW_INVOICE_LIST),
      showServiceProvider: hasRole(PERMISSIONS.VIEW_AGREEMENT),
      showSme: hasRole(PERMISSIONS.VIEW_CORE_INVOICE_LIST),
      smeTypes: ['standard', 'simplified'],
    };
    setRoutes(
      ROUTES({
        baseRoute,
        TAX_COUNTRY,
        config: routeConfig,
      }),
    );
    setIsInitialized(true);
  }, [roles, baseRoute]);

  return (
    <Routes>
      {isInitialized && renderRoutes(routes)}
      <Route path={baseRoute} element={<EInvoicingPortal />} />
    </Routes>
  );
};

export default React.memo(AppRoutes);
